/**
 * Range data structure.
 *
 * Used to perform an interval check like this : `[from, to[`.
 */
export type FromToRange<T> = {
  /**
   * Beginning of the range, included.
   */
  from: number;
  /**
   * End of the range, excluded.
   */
  to: number;
  /**
   * Value associated with the range.
   */
  value: T;
};

export function evaluateRange<T>(
  value: number,
  range: FromToRange<T>
): T | undefined {
  if (value >= range.from && value < range.to) return range.value;

  return;
}

export default evaluateRange;
